<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("authfack", ["loadingStatus"]),
  },
  methods: {
    ...mapActions("authfack", ["logout"]),
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    redirectLogin() {
      this.logout();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header flex-row">
      <div class="d-flex navbar-inner">
        <!-- LOGO -->
        <div class="brand">
              <img
                src="@/assets/images/logo-lg.svg"
                class="logo-img"
                alt="brand"
              />
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item d-none"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <span class="project_title">Passport</span>
      </div>
      <div class="d-flex align-items-center">
        <p @click="redirectLogin" class="logout no-wrap" :disabled="loadingStatus">
          Sign out
        </p>
      </div>
    </div>
  </header>
</template>
<style lang="scss" scoped>
@media (max-width: 992px){
  .brand{
    width:116px!important;
    height: 22px!important;
   img{
  width:116px!important;
  height: 22px!important;
}
}
}
.brand{
  width: 126px!important;
  height: 24px!important;
  .logo-img{
    width: 100%;
  }
}
span.project_title {
  color: #fff;
  font-size: 1.1rem;
  font-weight: normal;
  margin: 0;
}
.navbar-inner,
.navbar-header {
  align-items: center;
}
.navbar-header {
  padding: 31px 32px;
}
.logo-lg-style {
  height: 40px;
  object-fit: contain;
  width: 140px;
}
.logout {
  color: #f46a6a;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  cursor: pointer;
}
</style>
